export default __webpack_public_path__ + "static/media/backArrow.7279a766.svg";